import React from "react";
import { observer } from "mobx-react";
import { TextField } from "@mui/material";

function FormTextField(props) {
  return (
    <TextField
      margin="dense"
      size="small"
      color="primary"
      variant="outlined"
      sx={{
        "& .Mui-disabled.MuiOutlinedInput-root": {
          "& fieldset": {
            border: (theme) => `1px solid ${theme.palette.grey["300"]}`,
          },
        },
        "& label.Mui-focused": {
          color: "primary.main",
        },
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: "grey.blue24",
          },
          "&:hover fieldset": {
            borderColor: "primary.main",
          },
          "&.Mui-focused fieldset": {
            borderColor: "primary.main",
          },
        },
        "& .MuiInputBase-root": {
          height: "36px !important",
          width: "100%",
          cursor: "pointer",
          paddingTop: "2px",
          paddingBottom: "2px",
        },
      }}
      InputProps={{
        size: "small",
      }}
      {...props}
    />
  );
}

export default observer(FormTextField);
